import React from 'react';
import clsx from 'clsx';

import TextLimit from '@atom/components/common/TextLimit';
import { Icon, IconButton, TextField } from '@atom/mui';
import {
  MAX_CHAR_DESCRIPTION,
  MAX_CHAR_SHORT_INPUT,
  MAX_OPTIONS,
  REVEAL_LONG,
} from '@atom/selectors/formSelectors';

import classes from '../formBuilder.module.css';

interface Props {
  title: string;
  description: string;
  enumValue: string[];
  onChange: (event: Object) => void;
  updateOption: (event: Object) => void;
  removeOption: (index: number) => void;
  addOption: () => void;
}

const MultipleOptionInput = ({
  title,
  description,
  enumValue,
  onChange,
  updateOption,
  removeOption,
  addOption,
}: Props) => {
  return (
    <React.Fragment>
      <div className={classes.multiInputContainer}>
        <div className={classes.doubleInput}>
          <TextField
            value={title}
            onChange={onChange}
            name="title"
            label="Title"
          />
          <div className={classes.textLimitContainer}>
            <TextLimit
              limit={MAX_CHAR_SHORT_INPUT}
              reveal={REVEAL_LONG}
              text={title}
            />
          </div>
        </div>
        <div className={classes.doubleInput}>
          <TextField
            value={description}
            onChange={onChange}
            name="description"
            label="Description"
          />
          <div className={classes.textLimitContainer}>
            <TextLimit
              limit={MAX_CHAR_DESCRIPTION}
              reveal={REVEAL_LONG}
              text={description}
            />
          </div>
        </div>
      </div>
      <div className={classes.sectionText}>Options:</div>
      {enumValue ? (
        enumValue.map((option: string, index: number) => {
          return (
            <div key={index}>
              <div className={classes.optionsInputContainer}>
                <div className={classes.optionsNumber}>{`${index + 1}.`}</div>
                <TextField
                  value={option}
                  key={index}
                  onChange={updateOption}
                  id={index.toString()}
                />
                <IconButton onClick={(): void => removeOption(index)}>
                  <Icon>cancel</Icon>
                </IconButton>
              </div>
              <div className={clsx(classes.textLimitContainer, classes.option)}>
                <TextLimit
                  limit={MAX_CHAR_SHORT_INPUT}
                  reveal={REVEAL_LONG}
                  text={option}
                />
              </div>
            </div>
          );
        })
      ) : (
        <div />
      )}
      {enumValue.length < MAX_OPTIONS && (
        <div className={classes.optionsInputContainer}>
          <IconButton onClick={addOption}>
            <Icon>add_circle_outline</Icon>
          </IconButton>
          <div className={classes.addOptionText}>Add Option</div>
        </div>
      )}
    </React.Fragment>
  );
};

export default MultipleOptionInput;
